var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeNetIcoHeroSectionBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 880,
    viewBox: "0 0 1920 880",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_932_1228",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -18,
    y: -196,
    width: 1976,
    height: 1076
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433 879H1488.5M433 879V750.5M433 879H348M433 149V297.5M433 149L346.5 62.5M433 149H585M1488.5 149L1575 62.5M1488.5 149V298M1488.5 149H1336.5M1488.5 879H1575M1488.5 879V750M433 297.5L-16.5 6.5M433 297.5V449M433 449L-16.5 289.5M433 449V599.5M433 599.5L-16.5 547M433 599.5V750.5M433 750.5L-16.5 797.5M348 879L346.5 62.5M348 879H239.5M346.5 62.5L267 -17L239.5 -44.5M346.5 62.5H1575M1575 62.5V879M1575 62.5L1682 -44.5M1575 879H1682M239.5 879H90.5V-193.5L239.5 -44.5M239.5 879V-44.5M239.5 -44.5H460M1682 -44.5L1831 -193.5V879H1682M1682 -44.5V879M1682 -44.5H1464M1488.5 750L1957 802.5M1488.5 750V449.5M1487.5 599.5L1957 545.5M1488.5 449.5L1957 284.5M1488.5 449.5V298M1488.5 298L1957 -3.5M585 149L460 -44.5M585 149H735.5M460 -44.5H660.5M735.5 149L660.5 -44.5M735.5 149H886M660.5 -44.5H850.5M886 149L850.5 -44.5M886 149H1036M850.5 -44.5H1053.5M1036 149L1053.5 -44.5M1036 149H1186M1053.5 -44.5H1251.5M1186 149L1251.5 -44.5M1186 149H1336.5M1251.5 -44.5H1464M1336.5 149L1464 -44.5",
    stroke: "url(#paint0_linear_932_1228)",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_932_1228)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_932_1228)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 990,
    cy: 430.5,
    rx: 930,
    ry: 333.5,
    fill: "url(#paint1_linear_932_1228)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_932_1228",
    x: -240,
    y: -203,
    width: 2460,
    height: 1267,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_932_1228"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_932_1228",
    x1: -16.5,
    y1: 342.75,
    x2: 1957,
    y2: 342.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3BD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_932_1228",
    x1: 60,
    y1: 430.5,
    x2: 1920,
    y2: 430.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3BD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A246D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeNetIcoHeroSectionBg);
export default __webpack_public_path__ + "static/media/shape_net_ico_hero_section_bg.33110328efce7173bd8219b603aa5877.svg";
export { ForwardRef as ReactComponent };